document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  event.preventDefault();

  const submitButton = form.querySelector('[name="add"], [type="submit"]');
  submitButton?.setAttribute('disabled', 'disabled');
  submitButton?.classList.add('loading');

  const formData = new FormData(form);

  formData.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id).join(','));
  formData.append('sections_url', window.location.pathname);

  try {
    const response = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const parsed = await response.json();

    if (parsed.status) {
      console.error(parsed.description || parsed.message);
      return;
    }

    cartDrawer.renderContents(parsed);

    const cart = await (await fetch(`${routes.cart_url}.js`)).json();
    document.querySelectorAll('.js-cart-count').forEach((el) => {
      el.textContent = cart.item_count < 100 ? cart.item_count : '';
    });
  } catch (e) {
    console.error(e);
  } finally {
    submitButton?.removeAttribute('disabled');
    submitButton?.classList.remove('loading');
  }
});